import { useAuth } from '../auth/AuthProvider';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

export function AccountPage() {
  const { user, signOut } = useAuth();
  return (
    <div className="auth-card" style={{ maxWidth: 480 }}>
      <h2 className="text-white mb-2">Account</h2>
      <p className="text-cyan-300 mb-6">
        Signed in as <span className="font-medium">{user?.email}</span>
      </p>
      <Button
        variant="outline"
        onClick={async () => {
          await signOut();
          toast.message('Signed out');
        }}
      >
        Sign out
      </Button>
    </div>
  );
}
